<template>
    <div>
        <Loader ref="Loader"></Loader>
        <v-flex xs12>
            <v-card>
                <v-toolbar dense color="secondary" dark>
                    <v-toolbar-title>Customer Detail</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
            </v-card>
            <v-layout row wrap ma-2>
                <v-container>
                    <v-card>
                        <v-layout ma-2>
                            <v-flex lg3 xs3 sm3 mr-2>
                                <v-combobox label="Select customer" v-model="selectedCustomer" :items="customerItems"
                                    item-text="Name" item-value="ID" @change="FetchCustomerData()"></v-combobox>
                            </v-flex>
                            <v-spacer></v-spacer>
                            <v-flex xs4>
                                <v-text-field append-icon="search" v-model="search" placeholder="Search detail">
                                </v-text-field>
                            </v-flex>
                            <!-- <download-excel ref="downloadExcelRef" style="height:0px; opacity:0;" :data="excelData"
                                :fields="excelFields" :name="fileName"></download-excel>
                            <v-btn flat outline @click="FetchData()">Clear Filter</v-btn>
                            <v-btn flat outline @click="triggerExcel()">Export</v-btn> -->
                        </v-layout>
                        <v-layout justify-end>
                            <download-excel ref="downloadExcelRef" style="height:0px; opacity:0;" :data="excelData"
                                :fields="excelFields" :name="fileName"></download-excel>
                            <v-btn flat outline @click="ClearFilter()">Clear Filter</v-btn>
                            <v-btn flat outline @click="triggerExcel()">Export</v-btn>
                        </v-layout>
                        <v-data-table class="table" :headers="tableHeaders" :items="items"
                            :rows-per-page-items="[50, 75, 100]" :search="search">
                            <template v-slot:items="props">
                                <td>{{ props.index+1 }}</td>
                                <td class="text-xs-left">{{ props.item.CustomerName }}</td>
                                <td class="text-xs-left">{{ props.item.ContactTel }}</td>
                                <td class="text-xs-left">{{ props.item.EmailAddress }}</td>
                                <td class="text-xs-left">{{ props.item.Username }}</td>
                                <td class="text-xs-left">{{ props.item.Password }}</td>
                                <td class="text-xs-left">{{ props.item.RegionName }}</td>
                                <td class="text-xs-left">{{ props.item.Address }}</td>
                                <td class="text-xs-left">{{ props.item.CustomerVenues }}</td>
                                <td class="text-xs-left">{{ props.item.CustomerUsers }}</td>
                                <td class="text-xs-left">{{ props.item.Opsmanagers }}</td>
                                <td class="text-xs-left">{{ props.item.Supervisors }}</td>
                                <td class="text-xs-left">{{ props.item.CustomerInspections }}</td>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-container>

            </v-layout>
        </v-flex>
    </div>
</template>

<script>
    import JWT from "jsonwebtoken";

    export default {
        data() {
            return {
                search: null,
                selectedCustomer: null,
                items: [],
                customerItems: [],
                tableHeaders: [{},
                    {
                        text: 'Customer',
                        value: 'CustomerName',
                        align: 'left',
                        sortable: true
                    },
                    {
                        text: 'Telephone Number',
                        value: "ContactTel",
                        align: 'left',
                        sortable: true
                    },
                    {
                        text: 'Email Address',
                        value: "EmailAddress",
                        align: 'left',
                        sortable: true
                    },
                    {
                        text: 'Username',
                        value: "Username",
                        align: 'left',
                        sortable: true
                    },
                    {
                        text: 'Password',
                        value: "Password",
                        align: 'left',
                        sortable: true
                    },
                    {
                        text: 'Region',
                        value: "RegionName",
                        align: 'left',
                        sortable: true
                    },
                    {
                        text: 'Address',
                        value: 'Address',
                        align: 'left',
                        sortable: true
                    },
                    {
                        text: 'Venues',
                        value: 'CustomerVenues',
                        align: 'left',
                        sortable: true
                    },
                    {
                        text: 'Customer Users',
                        value: 'CustomerUsers',
                        align: 'left',
                        sortable: true
                    },
                    {
                        text: 'Ops Managers',
                        value: 'Opsmanagers',
                        align: 'left',
                        sortable: true
                    },
                    {
                        text: 'Supervisors',
                        value: 'Supervisors',
                        align: 'left',
                        sortable: true
                    },
                    {
                        text: 'Inspection Sheets',
                        value: 'CustomerInspections',
                        align: 'left',
                        sortable: true
                    },
                ],
                excelFields: {
                    "Customer": "CustomerName",
                    "Telephone Number": "ContactTel",
                    "Email Address": "EmailAddress",
                    "Username": "Username",
                    "Password": "Password",
                    "Region": "RegionName",
                    "Address": "Address",
                    "Venues": "CustomerVenues",
                    "Customer Users": "CustomerUsers",
                    "Ops Managers": "Opsmanagers",
                    "Supervisors": "Supervisors",
                    "Inspection Sheets": "CustomerInspections",
                },
                excelData: [],
                fileName: null,
                roleID: "",
                userID: 0
            }
        },
        mounted() {
            let self = this;
            let tokenDecoded = JWT.decode(localStorage.accessToken);
            console.log("[TOKEN DECODED]", tokenDecoded)

            self.userID = localStorage.getItem("USER_ID");
            console.log("USER_ID", self.userID)
            self.role = localStorage.getItem("Role");
            console.log("ROLE", self.role)
            self.FetchCustomers(self.role, self.userID);

            self.FetchData();
        },
        methods: {
            FetchData() {
                let self = this;

                self.$refs.Loader.show(true);
                self.$refs.Loader.setText("Loading...");
                self.get(`SQLReporting/CustomerWithDetail?customerID=${-1}`).then(r => {
                    self.$refs.Loader.hide();
                    console.log("[CUSTOMER DETAIL]", r.data);
                    self.items = r.data;
                })
            },
            FetchCustomerData() {
                let self = this;

                self.$refs.Loader.show(true);
                self.$refs.Loader.setText("Loading...");
                self.$nextTick(() => {
                    self.get(`SQLReporting/CustomerWithDetail?customerID=${self.selectedCustomer.ID}`).then(
                        r => {
                            console.log("[CUSTOMER DETAIL]", r.data);
                            self.$refs.Loader.hide();
                            self.items = r.data;
                        })
                })
            },
            FetchCustomers(role, userID) {
                let self = this;

                let url;

                switch (role.toLowerCase()) {
                    case "master": {
                        url = `Customer`;
                    }
                    break;
                case "admin": {
                    url = `Customer`;
                }
                break;
                default: {
                    url = `Customer/GetBySystemUser?systemUserID=${self.userID}`;
                }
                break;
                }

                if (role == "Master" || role == "Admin") {
                    self.get(`Customer`)
                        .then(response => {
                            self.customerItems = response.data;
                            //console.log("[CUSTOMER ITEMS]", self.customerItems);
                        })
                        .catch(error => {
                            self.$refs.ErrorModal.show();
                            self.$refs.ErrorModal.setText(error.toString());
                        });
                } else {
                    self.get(`Customer/GetBySystemUser?systemUserID=${self.userID}`)
                        .then(response => {
                            self.customerItems = response.data;
                            console.log("[CUSTOMER ITEMS]", self.customerItems);
                        })
                        .catch(error => {
                            self.$refs.ErrorModal.show();
                            self.$refs.ErrorModal.setText(error.toString());
                        });
                }
            },
            triggerExcel() {
                let self = this;
                self.$nextTick(() => {
                    self.fileName = "CustomerDetail";
                    self.excelData = self.items;
                    var vueJsonExcel = self.$refs.downloadExcelRef;
                    vueJsonExcel.$el.click();
                })
            },
            ClearFilter() {
                let self = this;
                self.FetchData();
                self.selectedCustomer = null;
            }
        }
    }
</script>

<style>

</style>